import React, { useState, useRef } from "react";
import {
  Typography
} from "@mui/material";

import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useParams } from 'react-router-dom';
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from '../../../actions/api';
import DispenserFormData from './LabTestEntryItems.js';

import Constants from "../../../services/Constants";




import { format } from 'date-fns';
const AddLabTestEntry = (props) => {

  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "entry-of-the-results-of-the-various-assessments-for-the-patients";
const FacilityId=localStorage.getItem('FacilityId');
  
const [selectedDate, setSelectedDate] = useState(
  // new Date()
  format(new Date(), 'yyyy-MM-dd')
);
const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState(
  ''
); 
  const [formData, setFormData] = useState({
      TransactionDate: selectedDate,
      TransactionNo: generatedInvoiceNo, 
      "FacilityId":FacilityId,
      TransactionTypeId:999,
      PatientId:"",
      idNumber:"",
      PatientFirstName:"",
      PatientLastName:"",
      ContactNumber:"",
      GenderTypeId:"",
      Dob:"",
      TestToFacilityId:"",
      PreparedBy:"",
      ApprovedBy: "",
      Remarks: "",
      bStockUpdated: 0,
      ItemGroupId:props.match.params.id, //Get the url send id
  });

   const [ManyTableData, setManyTableData] = useState( []); 
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);

   
  
const handleRDateChange = (date, field) => {
  
  let newDate;
  if(date==null){
   newDate=date;
  }else{
    newDate = format(new Date(date), 'yyyy-MM-dd');
  }

  setFormData({ ...formData, [field]: newDate });
  setErrorObject({ ...errorObject, [field]: null });


  // setFormData({ ...formData, [field]: date });
  // setErrorObject({ ...errorObject, [field]: null });


};

 const handleDateChange = (date) => {
  setSelectedDate(date);
}; 
 

  const [errorObject, setErrorObject] = useState({});
  const saveInFlightRef = useRef(false);
   
  const { id } = useParams();
  const queryClient = useQueryClient();

  let params={"menukey": "entry-of-the-results-of-the-various-assessments-for-the-patients", "FacilityId":FacilityId, "TransactionTypeId":999, TransactionDate: ''};
  const {  data:invoiceNo, refetch } = useQuery([params], api.getInvoiceNo, 
    {onSuccess: (data) => {
      
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData }; 
      fdata["TransactionNo"] = data; 
      setFormData(fdata); 

    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0,//1000 * 60 * 60 * 24,
  }
    );
  
 

  const { isLoading: isSaveMutating, mutate } = useMutation(api.saveLabTestEntryInv, {
    onSuccess: (data) => { 
      if (data.status == 200) {

      props.openNoticeModal({
        isOpen: true,
        msg: data.message,
        msgtype: data.success,
      });

     
      let route = `/${menukey}/edit/${data.TransactionId}`;
      props.history.push(route);  
      
      
      }else{
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    }
  })  

  const runSaveLabTestEntry = (payload) => {
    if (saveInFlightRef.current) return;
    saveInFlightRef.current = true;
    mutate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
  
      setManyTableData(NonOrderProductData);
      setUpdatedDetailGridData(NonOrderProductData);
      

  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;

      let data = { ...formData };
      
      data[name] = value; 
      setFormData(data); 
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      TransactionDate: selectedDate,
      TransactionNo: generatedInvoiceNo, 
      "FacilityId":FacilityId,
      TransactionTypeId:999,
      PatientId:"",
      idNumber:"",
      PatientFirstName:"",
      PatientLastName:"",
      ContactNumber:"",
      GenderTypeId:"",
      Dob:"",
      TestToFacilityId:"",
      PreparedBy:"",
      ApprovedBy: "",
      Remarks: "",
      bStockUpdated: 0,
      ItemGroupId:props.match.params.id, //Get the url send id
    });
    setManyTableData([]);  
  };

  const validateForm = (formData) => {
    let validateFields = ["TransactionDate", "TransactionNo","TestToFacilityId","PreparedBy","GenderTypeId","Dob"]
    let errorData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !']
        isValid = false
      }
    })
    setErrorObject(errorData);
    return isValid
  }

  const handleSubmit = async (e) => {
    if (saveInFlightRef.current || isSaveMutating) return;
    if (validateForm(formData)) {
      let fDtat={...formData,'ManyJsonSave':ManyTableData,"menukey":"entry-of-the-results-of-the-various-assessments-for-the-patients"};
      runSaveLabTestEntry(fDtat);
      
    }
  };
  const deleteReceiveInv=(data)=>{
    
    let newarray = ManyTableData.filter(element => element !== data); 
    setManyTableData(newarray);
     
    

  }

  const setUpdatedDetailsGridDataHandler = (rows) => { 
    if (saveInFlightRef.current || isSaveMutating) return;
    if (validateForm(formData)) {
      let fDtat={...formData,'ManyJsonSave':rows,"menukey":"entry-of-the-results-of-the-various-assessments-for-the-patients"}; 
      runSaveLabTestEntry(fDtat); 
      }

    setManyTableData(rows); 
  };

  const handleChangeissuedToFacilityProps = (e) => {
    if(e !== 'null'){
      setErrorObject({ ...errorObject, ['IssuedToFacility']: null });
    }
  };  

  const handleAddPatient = (PatientData) => {
    let fdata = { ...formData };
    let row = PatientData;

    fdata["PatientId"] = row[0].PatientId;
    fdata["idNumber"] = row[0].idNumber;
    fdata["PatientLastName"] = row[0].lastName;
    fdata["PatientFirstName"] = row[0].firstName;
    fdata["ContactNumber"] = row[0].contactNumber;
    fdata["Dob"] = row[0].dob;
    fdata["GenderTypeId"] = row[0].GenderTypeId;


    setFormData(fdata);
  };


  return (
    <> 
      <DispenserFormData 
      errorObject={errorObject} 
      addProductForm={true} 
      formData={formData} 
      handleChange={handleChange} 
      handleCheck={handleCheck} 
      handleReset={handleReset} 
      handleSubmit={handleSubmit} 
      ManyTableData={updatedDetailGridData}   
      handleRDateChange={handleRDateChange} 
      handleChangeissuedToFacilityProps={handleChangeissuedToFacilityProps} 
      selectedDate={selectedDate} 
      deleteReceiveInv={deleteReceiveInv}
      setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
      bStockUpdate={props.permissionType}
      handleAdd={handleAdd} 
      handleAddPatient={handleAddPatient}
      generatedInvoiceNo={generatedInvoiceNo}
      {...props}
      isSubmitting={isSaveMutating}
      />
      
      
    </>

    
  );
};

export default AddLabTestEntry;